import { baseApi } from "./base.api";

export const contactsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    sendContactMessage: build.mutation({
      query: (body) => ({ url: "/contacts/send", method: "POST", body }),
      invalidatesTags: ["ContactMessage"],
    }),
    fetchContactMessages: build.query({
      query: (params) => ({ url: "/contacts/fetch", method: "GET", params }),
      providesTags: ["ContactMessage"],
    }),
    fetchContactMessagesAll: build.query({
      query: () => ({ url: "/contacts/fetch/all", method: "GET" }),
      providesTags: ["ContactMessage"],
    }),
    fetchTrashedContactMessages: build.query({
      query: (params) => ({ url: "/contacts/fetch/trashed", method: "GET", params }),
      providesTags: ["ContactMessage"],
    }),
    fetchContactMessageById: build.query({
      query: (id) => ({ url: `/contacts/fetch/${id}`, method: "GET" }),
      providesTags: ["ContactMessage"],
    }),
    replyContactMessage: build.mutation({
      query: ({ id, body }) => ({ url: `/contacts/reply/${id}`, method: "PUT", body }),
      invalidatesTags: ["ContactMessage"],
    }),
    deleteContactMessage: build.mutation({
      query: (id) => ({ url: `/contacts/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["ContactMessage"],
    }),
    bulkDeleteContactMessages: build.mutation({
      query: (body) => ({ url: "/contacts/bulk-delete", method: "POST", body }),
      invalidatesTags: ["ContactMessage"],
    }),
    restoreContactMessage: build.mutation({
      query: (id) => ({ url: `/contacts/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["ContactMessage"],
    }),
    destroyContactMessage: build.mutation({
      query: (id) => ({ url: `/contacts/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["ContactMessage"],
    }),
    bulkDestroyContactMessages: build.mutation({
      query: (body) => ({ url: "/contacts/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["ContactMessage"],
    }),
  }),
});

export const {
  useSendContactMessageMutation,
  useFetchContactMessagesQuery,
  useFetchContactMessagesAllQuery,
  useFetchTrashedContactMessagesQuery,
  useFetchContactMessageByIdQuery,
  useReplyContactMessageMutation,
  useDeleteContactMessageMutation,
  useBulkDeleteContactMessagesMutation,
  useRestoreContactMessageMutation,
  useDestroyContactMessageMutation,
  useBulkDestroyContactMessagesMutation,
} = contactsApi;
